import { render, staticRenderFns } from "./Logout.vue?vue&type=template&id=6bd73d31&scoped=true"
import script from "./Logout.vue?vue&type=script&lang=js"
export * from "./Logout.vue?vue&type=script&lang=js"
import style0 from "./Logout.vue?vue&type=style&index=0&id=6bd73d31&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd73d31",
  null
  
)

export default component.exports